module.exports = __webpack_public_path__ + "img/9x16_collage.20553870.jpg";